import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const MessageToast = ({ open, handleClose, message, severity = "success" }) => {

    return (
        <Snackbar 
      open={open} 
      autoHideDuration={4000} // Closes automatically after 4 seconds
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} // Position
    >
        <Alert 
        onClose={handleClose} 
        severity={severity} 
        variant="filled" 
        sx={{ width: '100%' }}
      >
        {message}
      </Alert>
    </Snackbar>
    );
}

export default MessageToast;